export enum UserEvents {
    UPDATED = 'updated',
    LOGIN_SUCCESS = 'loginSuccess',
    LOGGED_OUT = 'loggedOut',
    ERROR = 'error',
}
